import { render, staticRenderFns } from "./FilmItem.vue?vue&type=template&id=f5b976a2&"
import script from "./FilmItem.vue?vue&type=script&lang=js&"
export * from "./FilmItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5b976a2')) {
      api.createRecord('f5b976a2', component.options)
    } else {
      api.reload('f5b976a2', component.options)
    }
    module.hot.accept("./FilmItem.vue?vue&type=template&id=f5b976a2&", function () {
      api.rerender('f5b976a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/home/components/FilmItem.vue"
export default component.exports